export function bsb_rbp_description(code) {
    return _bsb_rbp_description[code];
}
export const _bsb_rbp_description = {
    1: 'SLT переключ',
    2: 'Отказ',
    3: 'Монитор переключ',
    4: 'Ручное управление активно',
    5: 'Функция чистки дымохода, полный нагрев',
    6: 'Функция чистки дымохода, частичный нагрев',
    7: 'Активация функции чистки дымохода',
    8: 'Ручная блокировка',
    9: 'Автоматическая блокировка',
    10: 'Блокировка',
    11: 'Защитный пуск',
    12: 'Защитный пуск, частичный нагрев',
    13: 'Огранич. обр',
    14: 'Огранич. Обр, частичный нагрев',
    15: 'Разрешено',
    16: 'Разрешено на запуск частичного нагрева',
    17: 'Выбег актив',
    18: 'В работе',
    19: 'Разрешено',
    20: 'Минимальное ограничение',
    21: 'Минимальное ограничение, частичная нагрузка',
    22: 'Минимальное ограничение активно',
    23: 'Защита от заморозки активна',
    24: 'Защита от заморозки активна',
    25: 'Выкл',
    26: 'Аварийная работа',
    27: 'Блокировка, внешняя',
    28: 'Ограничение минимальной температуры источника',
    29: 'Высокое давление в режиме ТП',
    30: 'Реле потока источника тепла',
    31: 'Реле давления источника тепла',
    32: 'Ограничение компр. 1 гор газа',
    33: 'Ограничение компр. 2 гор газа',
    34: 'Предел откл темп макс',
    35: 'Минимальное время выключения компр. Акт.',
    36: 'Компенсация избытка тепла',
    37: 'Ограничение времени актив.',
    38: 'Минимальное время работы компр, актив.',
    39: 'Деффицит комп отопления',
    40: 'Предел переп конд макс',
    41: 'Предел переп конд мин',
    42: 'Предел переп исп макс',
    43: 'Предел переп конд мин',
    44: 'Компр 1 и эл. Вкл',
    45: 'Компрессоры 1 и 2 включены',
    46: 'Компрессор 1 вкл',
    47: 'Компрессор 2 вкл',
    48: 'Защита от замораживания ТН',
    49: 'Подача активна',
    50: 'Разрешение на пуск испарителя готов',
    51: 'Нет запроса',
    52: 'Защита зам коллектора активна',
    53: 'Повторное охлаждение активно',
    54: 'Макс темп нак бак достиг',
    55: 'Защита испарения активна',
    56: 'Защита перегрева активна',
    57: 'Максимальная температура загрузки достигнута',
    58: 'Загрузка ГВС',
    59: 'Бзагрузка буфера',
    60: 'Загрузка бассейна',
    61: 'Минимальная температура загрузки не достигнута',
    62: 'Недостаточный температурный перепад',
    63: 'Недостаточная теплоотдача',
    64: 'Эл загр, авар режим',
    65: 'Эл загр, защита источника',
    66: 'Загр эл погр нагреватель',
    67: 'Принудительная загрузка активна',
    68: 'Частичная загрузка активна',
    69: 'Загрузка активна',
    70: 'Загрузка, максимальная температура накопительного бака',
    71: 'Загрузка, максимальная температура',
    72: 'Загружен, принудительная температура',
    73: 'Загружен, требуемая температура',
    74: 'Частично загружен, требуемая температура',
    75: 'Загружен',
    76: 'Холодный',
    77: 'Повторное охлаждение ч/коллектор',
    78: 'Повторное охлаждение ч/тепген/КО',
    79: 'Защита загрузки активна',
    80: 'Ограничение времени загрузки активно',
    81: 'Загрузка блокирована',
    82: 'Блок загрузки актив',
    83: 'Принудительно, макс темп накопительного бака',
    84: 'Принудительно, макс загрузка температуры',
    85: 'Принудительно, уст. легионеллы',
    86: 'Принудительно, ном уставка',
    87: 'Эл загр-а, уставка Легионелла',
    88: 'Эл загрузка, ном уставка',
    89: 'Эл загр-а, пониженная уставка',
    90: 'Эл загрузка, уст защит заморозка',
    91: 'Эл погруж нагрев разр',
    92: 'Толчок, уставка Легионелла',
    93: 'Толчок ном уставка',
    94: 'Толчок активен',
    95: 'Загрузка , уставка легионелла',
    96: 'Загрузка, номинальная уставка',
    97: 'Загрузка, пониженная уставка',
    98: 'Загрузка, темп Легионелла',
    99: 'Загрузка, номинальная температура',
    100: 'Загрузка, пониженная температура',
    101: 'Защита заморозки комнаты активна',
    102: 'Функция сушки пола активна',
    103: 'Огранич, защита котла',
    104: 'Огранич, приоритет ГВС',
    105: 'Огранич, буфер',
    106: 'Режим отопления огранич',
    107: 'Принудительное нагнетание буфера',
    108: 'Принудительное нагнетание ГВС',
    109: 'Источник принудительного нагнетания',
    110: 'Принудительное нагнетание',
    111: 'Опт рег зап +уск нагрев',
    112: 'Оптимальное управление запуском',
    113: 'Ускоренный нагрев',
    114: 'Режим отопления комфорт',
    115: 'Оптимальное регулирование останова',
    116: 'Пониженный режим отопления',
    117: 'Подача защ замор активна',
    118: 'Работа летом',
    119: 'ECO актив. 24 часа',
    120: 'Сниж возврат',
    121: 'Возвр защ от замораживания',
    122: 'Ограничение комнатной температуры',
    123: 'Тест SLT активен',
    124: 'Загрузка ограничена',
    125: 'Размораживание активно',
    126: 'Спуск конденсата',
    127: 'Активный режим охлаждения',
    128: 'Пассивный режим охлаждения',
    129: 'Охлаждение испарителя',
    130: 'Предварительный нагрев для рамораж.',
    131: 'Эл загрузка при размораж.',
    132: 'Принудительное размораживание активно',
    133: 'Монитор точки росы',
    134: 'Предел охлаж НТ актив',
    135: 'Время блокировки после отопления',
    136: 'Увел. Уст. Темп. Под.гигр.',
    137: 'Режим отопления',
    138: 'Режим охлаждения отключен',
    139: 'Перед откл мин темп',
    140: 'Отопл откл/охлаж блок',
    141: 'Защита заморозки котла активна',
    142: 'Повторное охлаждение ч/ГВС/Ко',
    143: 'Загр, мин температура загр',
    144: 'Режим охлаждения огранич',
    145: 'Пред темп откл макс охл',
    146: 'Режим охлаждения блок',
    147: 'Тепло',
    148: 'Режим охлаждения готов',
    149: 'Режим защиты охлаждения',
    150: 'Режим охлаждения комфорт',
    151: 'Загр ГВС + буф + бассейн',
    152: 'Загр ГВС + буфер',
    153: 'Загр ГВС + бассейн',
    154: 'Загр  буфер + бассейн',
    155: 'Режим нагр источника',
    156: 'Нагрев, максимальная температура бассейна',
    157: 'Нагрев, уставка источника',
    158: 'Нагрев, уставка коллектора',
    159: 'Нагрев',
    160: 'Режим нагр сол. Коллектора откл',
    161: 'Режим нагр. Источн откл',
    162: 'Режим нагрев выключен',
    163: 'Пилотн. Горелка активна',
    164: 'Электр. Загр. форс',
    165: 'Электр. Загр. Замен',
    166: 'В работе для КО',
    167: 'В режиме част. Нагр. Для КО',
    168: 'В работе для ГВС',
    169: 'В режиме част. Нагр. Для ГВС',
    170: 'В работе для КО, ГВС',
    171: 'В режиме част. Нагр. Для ГВС, КО',
    172: 'Блок, твёрдотопливный котёл',
    173: 'Вкл для КО, ГВС',
    174: 'Вкл для ГВС',
    175: 'Вкл для КО',
    176: 'Зап., наруж. Температура',
    177: 'Огр. Подачи, мин. Точка росы',
    178: 'Огр. Подачи, мин. Наружняя температура',
    179: 'Предел подачи достигнут',
    180: 'Перекос фаз 3Ф тока',
    181: 'Низкое давление',
    182: 'Перегрузка вент.',
    183: 'Перегрузка компр. 1',
    184: 'Перегрузка компр. 2',
    185: 'Перегрузка насоса источника',
    186: 'Реле прот потребит.',
    187: 'Мин раб пред нар темп',
    188: 'Макс раб пред нар темп',
    189: 'Мин темп ист, вода',
    190: 'Мин темп ист, рассол.',
    191: 'Огр макс темп источн.',
    192: 'Форс. Комп. Размораж',
    193: 'Форс. Вент.размораж.',
    194: 'Размораж. Декомпр.',
    195: 'Размораж. Вент.',
    196: 'Огран. Мин. Темп. Ист',
    197: 'Электр. Вкл',
    198: 'Выкл., режим эконом',
    199: 'Потребеление',
    200: 'Готов',
    201: 'Загрузка',
    202: 'Защита замораж. Охл актив.',
    203: 'Полная загрузка',
    204: 'Блок режим обогрева',
    205: 'Выкл., источник',
    206: 'Выкл., буфер',
    207: 'Комп мин времени работы, охл',
    208: 'Компрес 1 и 2 вкл, охл',
    209: 'Компрес 1 вкл, режим охл',
    210: 'Компрес 2 вкл, режим охл',
    211: 'Блокировка',
    212: 'Предотвращение запуска',
    213: 'Закрывание',
    214: 'Время безопасности',
    215: 'Пуск',
    216: 'Резерв',
    217: 'Тестирование',
    218: 'Предпродувка',
    219: 'Постпродувка',
    220: 'Останов акт контроллера',
    221: 'Держ гор реж вкл',
    222: 'Держ гор реж актив',
    223: 'Пост нагреватель защ замораживания',
    224: 'Зажигание',
    225: 'Время установл',
    226: 'Операция спец газа',
    227: 'Тест дрейфа активирован',
    228: 'Спец операция',
    229: 'Режим установки',
    230: 'Инд уст котла актив',
    231: 'Ручн старт теста дрейфа',
    232: 'Темп топ газов, откл',
    233: 'Темп топ газов, вых красн',
    234: 'Слишком высокая температура топ. Газов',
    235: 'Давление воды низкое',
    236: 'Функция вечеринка активна',
    237: 'Перенос, уст легионелла',
    238: 'Перенос, номинал уставка',
    239: 'Перенос, понижен уставка',
    240: 'Перенос, актив',
    241: 'Использ ост тепла',
    242: 'Перемешивание активировано',
    243: 'Разреш поддерживания гор реж',
    244: 'Разреш источника',
    245: 'Выход предел SLT',
    246: 'Пониженное напряжение',
    247: 'Актив защ пад темп',
    248: 'Постоянная работа насоса',
    249: 'Загр оп эф до уст номин',
    250: 'Загр оп эф до уст легионеллы',
    251: 'Загр эф запр эл устр ном',
    252: 'Загр эф запр эл устр легионеллы',
    253: 'Поток подачи очень мал',
    254: 'Откачка хладоагента ручная',
};
